<div class="social-links">
  <ng-template [ngForOf]="socialNetworkLinks" ngFor let-item>
    <a
      [href]="handleItemHref(item)"
      [target]="handleItemTarget(item)"
      (click)="socialClick($event, item.name)"
      (clickOutside)="socialPopupClose(item.name)"
      class="social-link"
      appClickOutside 
    >
      <div class="social-link__icon social-link__icon--{{ item.name }}">
        <ng-container *ngIf="item.name === 'wechat' || item.name === 'line'">
          <ng-container
            *ngTemplateOutlet="QRRef; context: { name: item.name }"
          ></ng-container>
        </ng-container>
      </div>
    </a>

    <ng-template #QRRef let-name="name">
      <div
        *ngIf="socialPopup[name]"
        class="b-social__modal b-social__modal--qr"
      >
        <img
          [src]="'./assets/img/' + name + '-qr.png'"
          [alt]="name + ' QR code'"
        />
      </div>
    </ng-template>
  </ng-template>
</div>
